import { Tooltip } from 'antd'
import AntdButton from 'antd/lib/button'
import clsx from 'clsx'
import Translate from './Translate/Translate'

export default function Button({
  label,
  type = 'button',
  variant = 'default',
  className,
  success,
  tooltip,
  icon,
  ...props
}) {
  return (
    <Tooltip color="#25aae1" title={tooltip ? <Translate>{tooltip}</Translate> : null}>
      <AntdButton
        className={clsx(className, success && 'ant-btn-success')}
        htmlType={type}
        type={variant}
        {...props}>
        {icon && icon}
        {icon && label && <span style={{ paddingLeft: 10 }} />}
        {label ? <Translate>{label}</Translate> : null}
        {props.children ? <Translate>{props.children}</Translate> : null}
      </AntdButton>
    </Tooltip>
  )
}
